import { render, staticRenderFns } from "./GameIconDownload.vue?vue&type=template&id=60829006"
import script from "./GameIconDownload.vue?vue&type=script&lang=js"
export * from "./GameIconDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports